export const pageMapping = {
  119: 'suedbayerisches-huegelland',
  120: 'spessart-rhoen',
  121: 'mainregion',
  122: 'ostbayerisches-huegel-und-bergland',
  123: 'donauregion',
  124: 'alpen',
  125: 'alpenvorland',
};

export const pathMapping = {
  'suedbayerisches-huegelland': { value: 119, label: 'Südbayerisches-Hügelland'},
  'spessart-rhoen': { value: 120, label: 'Spessart-Rhön'},
  'mainregion': { value: 121, label: 'Mainregion'},
  'ostbayerisches-huegel-und-bergland': { value: 122, label: 'Ostbayerisches-Hügel-und-Bergland'},
  'donauregion': { value: 123, label: 'Donauregion'},
  'alpen':  { value: 124, label: 'Alpen'},
  'alpenvorland': { value: 125, label: 'Alpenvorland'},
};
